module.exports = __webpack_public_path__ + "static/media/lock.46c95929.svg";